import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const auth = {
  login: (email, password) => api.post('/auth/login', { email, password })
};

export const accounts = {
  getAll: () => api.get('/accounts'),
  create: (name) => api.post('/accounts', { name }),
  update: (id, name) => api.put(`/accounts/${id}`, { name }),
  delete: (id) => api.delete(`/accounts/${id}`)
};

export const lists = {
  getAll: () => api.get('/lists'),
  create: (externalId, accountId, status) => 
    api.post('/lists', { externalId, accountId, status }),
  update: (id, externalId, status) => 
    api.put(`/lists/${id}`, { externalId, status }),
  delete: (id) => api.delete(`/lists/${id}`)
};

export const publicApi = {
  getAccountsAndLists: () => api.get('/public/accounts-lists')
};

export default api; 